<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive">
        <!-- 这里是会被缓存的视图组件，比如 Home！ -->
      </router-view>
    </keep-alive>

    <router-view v-if="!$route.meta.keepAlive">
      <!-- 这里是不被缓存的视图组件，比如 Edit！ -->
    </router-view>
    <span id="bpp">版本号：{{FrontVersion}}</span>
  </div>
</template>

<script>
export default {
  name: "App",
  data () {
    return {
      FrontVersion: this.FrontVersion,
      agentlist: [],
    };
  },
  created () {
    this.getversion();
    this.getagentid();
  },
  methods: {
    getversion () {
      this.$opsaxios
        .get("/api/v1/version", {
          headers: {

          },
        })
        .then((res) => {
          // console.log('调度工单列表', res);
          if (res.data.code == "0") {
            if (
              this.FrontVersion != res.data.data.front_version &&
              this.FrontVersion != "${FrontVersion}"
            ) {
              this.$message({
                type: "error",
                message: "请清除缓存当前版本不是最新版本！",
              });
            } else {
              this.FrontVersion = res.data.data.front_version;
            }
          }
        });
    },
    getagentid () {
      this.$opsaxios
        .post(
          "/api/v1/member/agent/list",
          {
            status: 1,
            agenttype: 0,
          },
          {
            headers: {

            },
          }
        )
        .then((res) => {
          // console.log('调度工单列表', res);
          if (res.data.code == "0") {
            
            this.agentlist = res.data.data;
            for(let i = this.agentlist.length -1; i >= 0; i--) {
                if(this.agentlist[i].agent_arrange_scheme == '1') {
                  this.agentlist.splice(i, 1)
                }
            }
            let _agentlist = JSON.stringify(this.agentlist);
            localStorage.setItem("total_angetlist", _agentlist);
            // console.log("_agentlist", _agentlist)
          } else {
            // this.$message({
            //   type: "error",
            //   message: res.data.message,
            // });
          }
        });
    },
  },
};
</script>

<style>
@import "../static/css/common.css";
#bpp {
  z-index: 100;
  display: inline;
  position: absolute;
  bottom: 4px;
  right: 20px;
  color: rgba(0, 0, 0, 0.5);
  font-size: 14px;
}
.weintit {
  font-size: 20px;
  font-weight: bold;
}
.link {
  color: blue;
  text-decoration: underline;
}
.infolist {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
  cursor: pointer;
  min-width: 180px;
}
.infolist:hover {
  background: rgb(219, 216, 216);
}
.el-tabs__active-bar {
  /* background: #07ddd7 !important; */
}
.el-tabs__item.is-active {
  /* color: #07ddd7; */
}
/* ElementUI 修改图片预览默认大小 */
.el-image-viewer__img {
  width: auto !important;
  height: 100% !important;
}
</style>


// WEBPACK FOOTER //
// src/App.vue